'use client';

import { useEffect, useState } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import styles from './CalcHeader.module.scss';

const INITIAL_VALUE = 12_086_524_731;
const MIN_INCREMENT = 5;
const MAX_INCREMENT = 20;

const formatDigits = (value: number) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const RollingDigit = ({ value }: { value: string }) => {
	const [previousValue, setPreviousValue] = useState(value);
	const [isRolling, setIsRolling] = useState(false);

	useEffect(() => {
		if (value === previousValue) return;

		setIsRolling(true);
		setPreviousValue(value);
	}, [previousValue, value]);

	return (
		<span
			className={`${styles.amountDigit} ${isRolling ? styles.amountDigitRolling : ''}`}
			onAnimationEnd={() => setIsRolling(false)}
		>
			<span className={styles.amountDigitTrack}>
				<span className={styles.amountDigitFace}>{previousValue}</span>
				<span className={styles.amountDigitFace}>{value}</span>
			</span>
		</span>
	);
};

export const AnimatedCounter = () => {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	const [value, setValue] = useState(INITIAL_VALUE);

	useEffect(() => {
		const interval = window.setInterval(() => {
			const increment =
				Math.floor(Math.random() * (MAX_INCREMENT - MIN_INCREMENT + 1)) + MIN_INCREMENT;
			setValue((currentValue) => currentValue + increment);
		}, 1000);

		return () => window.clearInterval(interval);
	}, []);

	return (
		<span
			className={styles.amountValue}
			aria-live="polite"
			aria-label={t('promo.amount-aria', { value })}
		>
			{formatDigits(value)
				.split('')
				.map((character, index) =>
					character === ' ' ? (
						<span className={styles.amountSeparator} key={`${index}-separator`} />
					) : (
						<RollingDigit value={character} key={index} />
					),
				)}
		</span>
	);
};
